import { render, staticRenderFns } from "./BarTrendWidget.vue?vue&type=template&id=27b0ac10&scoped=true"
import script from "./BarTrendWidget.vue?vue&type=script&lang=js"
export * from "./BarTrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0ac10",
  null
  
)

export default component.exports